import React from 'react';
import Icon, { IconProps } from '../../icon';
import useStyles from './styles';

export const Beehive = (): string => {
  const classes = useStyles();
  return classes.beehive;
};

export const BeehiveIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.beehive} {...props} />;
};

export const Hamburger = (): string => {
  const classes = useStyles();
  return classes.hamburger;
};

export const HamburgerIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.hamburger} {...props} />;
};

export const HamburgerAlt = (): string => {
  const classes = useStyles();
  return classes.hamburgerAlt;
};

export const HamburgerAltIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.hamburgerAlt} {...props} />;
};

export const HamburgerAltReverse = (): string => {
  const classes = useStyles();
  return classes.hamburgerAltReverse;
};

export const HamburgerAltReverseIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.hamburgerAltReverse} {...props} />;
};
